module.exports = __webpack_public_path__ + "img/4.faa3afbf.png";